
export default class CareersListing {

	static getHolderSelectors = () => ['.careers-listing-element'];

	/** @type {HTMLElement} */
	#holderElement;
	#jobs = null;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		this.#sort();

		const searchParams = new URLSearchParams(window.location.search);
		const state = searchParams.get('state') ?? 'all';
		const suburb = searchParams.get('suburb') ?? 'all';

		window.htmx.onLoad(target => {
			if (target.dataset.template === 'careers-filters') {
				target.querySelectorAll('input').forEach(input => {
					input.addEventListener('change', event => {
						this.#filter('all', event.target.value);
					});
				});
			}
			if (target.dataset.template === 'careers-listing') {
				this.#filter(state, suburb);
			}
		});
	}

	#sort() {
		this.#holderElement.querySelectorAll('[name="sort-by-option"]').forEach(input => {
			input.addEventListener('change', event => {
				if (!this.#jobs) {
					this.#jobs = this.#holderElement.querySelectorAll('.job');
				}
				const order = event.target.value === 'newest-to-oldest' ? 1 : -1;
				this.#jobs.forEach(job => {
					const date = parseInt(job.dataset.sortBy);
					job.style = 'order: ' + (isNaN(date) ? 0 : date * order);
				});
			});
		});
	}

	#filter(state, suburb) {
		if (!this.#jobs) {
			this.#jobs = this.#holderElement.querySelectorAll('.job');
		}
		const searchSummary = this.#holderElement.querySelector('.result');
		let count = 0;
		this.#jobs.forEach(job => {
			const stateMatch = job.dataset.careerStateFilter === state || state === 'all';
			const suburbMatch = job.dataset.careerSuburbFilter === suburb || suburb === 'all';
			if (stateMatch && suburbMatch) {
				job.classList.remove('d-none');
				count++;
			} else {
				job.classList.add('d-none');
			}
		});
		if (count === 0) {
			this.#jobs.forEach(job => job.classList.remove('d-none'));
			count = this.#jobs.length;
		}
		if (searchSummary) {
			searchSummary.textContent = `We found ${count} available job` + ((count === 1) ? '' : 's');
		}
	}

}
